<template>
  <div class="
    uk-margin-large-top
    uk-margin-xlarge-bottom
    uk-grid-match
    uk-padding-medium-left
  " uk-grid>
    <USPCard
      :icon="usp1"
      link="/"
      title="Binnen 24 uur geleverd"
    >
      Ik probeer zo snel mogelijk te leveren, meestal dit binnen 24 uur of nog eerder.
    </USPCard>

    <USPCard
      :icon="usp2"
      link="/"
      title="Professioneel acteur"
    >
      Veel ervaring om snel verschillende tonen en sferen neer te zetten!
    </USPCard>

    <USPCard
      :icon="usp3"
      link="/"
      title="Niet tevreden? Dan opnieuw!"
    >
      Als ik onverhoopt niet de juiste toon te pakken heb, doe ik het gewoon over.
    </USPCard>
  </div>
</template>

<script>
import USPCard from '@/components/USPCard.vue';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const usp1 = require('@/assets/images/icons/icon-usp1@2x.png');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const usp2 = require('@/assets/images/icons/icon-usp2@2x.png');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const usp3 = require('@/assets/images/icons/icon-usp3@2x.png');

export default {
  name: 'USPCardContainer',
  data() {
    return {
      usp1: usp1.default ?? usp1,
      usp2: usp2.default ?? usp2,
      usp3: usp3.default ?? usp3,
    };
  },
  components: {
    USPCard,
  },
};
</script>

<style scoped>

</style>
